var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8000",
  fillRule: "evenodd",
  d: "M3.833 0h13.334A3.333 3.333 0 0 1 20.5 3.333v13.334A3.333 3.333 0 0 1 17.167 20H3.833A3.333 3.333 0 0 1 .5 16.667V3.333A3.333 3.333 0 0 1 3.833 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.278 15.556-5.555-5.332L4.289 8.72l3.99 3.818 8.433-8.094 1.566 1.515z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkOutline);
export default ForwardRef;